package com.milta.feature.settings.presentation

import com.milta.feature.subscription.domain.entity.SubscriptionPlan

/**
 * State for the web dashboard's "Paramètres" screen (MIL-53): Organisation profile (read-only),
 * interface language, subscription info (read-only) and the Organisation-deletion critical zone.
 * A single screen/ViewModel aggregating existing profile/team/subscription use cases, the same
 * consolidation pattern as [com.milta.feature.team.presentation.WebTeamState] for MIL-49.
 */
data class WebSettingsState(
    val isLoading: Boolean = false,

    // Profil de l'Organisation — nom en lecture seule, modification hors MVP.
    val organizationName: String? = null,

    // Langue de l'interface web — Account.Language (backend), même mécanisme que ProfileViewModel,
    // n'affecte jamais la langue des Chauffeurs (préférence par compte, pas par Organisation).
    val language: String? = null,
    val isLanguageSaving: Boolean = false,
    /** "server_error" | "offline" */
    val languageError: String? = null,

    // Abonnement — lecture seule, combine GetMySubscriptionUseCase (plan/expiry) et
    // GetSubscriptionPlansUseCase (prix/devise/cycle, catalogue public).
    val subscriptionPlan: SubscriptionPlan? = null,
    val subscriptionPrice: Double? = null,
    val subscriptionCurrency: String? = null,
    val subscriptionBillingPeriod: String? = null,
    val subscriptionExpiresAt: String? = null,

    // Suppression définitive de l'Organisation.
    val deleteConfirmationInput: String = "",
    val showDeleteConfirmDialog: Boolean = false,
    val isDeleting: Boolean = false,
    /** "server_error" | "offline" */
    val deleteError: String? = null,
)
